<app-base-modal
  [title]="'Процесс загрузки'"
>
  <app-file-progress-bar-status/>
</app-base-modal>
